// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoPurposeType } from './contactInfoPurposeType.js';
import type { ContactInfoType } from './contactInfoType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CasePhoneModel {
    'phoneId'?: number;
    'phoneType'?: ContactInfoType;
    'phonePurpose'?: ContactInfoPurposeType;
    'phoneNumber'?: string;
    'extension'?: string;
    'isVoicemailOptedIn'?: boolean;
    'isPrimary'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CasePhoneModel>> = [
        {
            "name":     "phoneId",
            "baseName": "phoneId",
            "type":     "number"
        },
        {
            "name":     "phoneType",
            "baseName": "phoneType",
            "type":     "ContactInfoType"
        },
        {
            "name":     "phonePurpose",
            "baseName": "phonePurpose",
            "type":     "ContactInfoPurposeType"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "extension",
            "baseName": "extension",
            "type":     "string"
        },
        {
            "name":     "isVoicemailOptedIn",
            "baseName": "isVoicemailOptedIn",
            "type":     "boolean"
        },
        {
            "name":     "isPrimary",
            "baseName": "isPrimary",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return CasePhoneModel.attributeTypeMap;
    }
}
